import { render, staticRenderFns } from "./BaseDepartmentRow.vue?vue&type=template&id=4ade0d4b&"
import script from "./BaseDepartmentRow.vue?vue&type=script&lang=js&"
export * from "./BaseDepartmentRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports